import { render } from "./TemplateEight.vue?vue&type=template&id=df8597f4"
import script from "./TemplateEight.vue?vue&type=script&lang=js"
export * from "./TemplateEight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__